import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HeadersRolesTable = () => {
  const navigate = useNavigate();
  return (
    <Grid container spacing={4} display={"flex"} alignItems={"center"}>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"flex-end"}
      >
        <Button
          variant="contained"
          onClick={() => navigate(`create`)}
          sx={{ background: "#336B87" }}
        >
          Crear rol
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeadersRolesTable;
